import { Dispatch } from 'redux'
import * as Api from 'lib/api'
import { Information } from 'core/domain/information'

export function getInformation(dispatch: Dispatch) {
  // Send GET information/
  return Api.callApi<{ information: Information[] }, undefined>(Api.HttpMethod.get, 'information', null, dispatch)
}
